import script from "./Invoicer.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoicer.vue?vue&type=script&setup=true&lang=js"

import "./Invoicer.vue?vue&type=style&index=0&id=2bc1e857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc1e857"]])

export default __exports__